/**
 * Shared API base URL.
 *
 * Extracted into its own tiny module so both `api-client.ts` and `auth-refresh.ts`
 * can read it without an import cycle (`api-client` → `auth-refresh` → `api-client`).
 */
export const BASE_URL = import.meta.env.VITE_API_BASE_URL ?? "http://localhost:3001/api/v1";
